<template>
  <div class="mb-3">
    <label for="company-search" class="form-label">Search existing companies</label>
    <ue-select
      class="w-100"
      searchable
      id="company-search"
      :options="companies"
      v-model="company"
      placeholder="Type to search…"
      @search="fetchCompanies"
      @input="selected"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import throttle from 'lodash/throttle'
import admin_api from '@app/mixins/admin_api'

export default defineComponent({
  name: 'CompanySelector',
  mixins: [admin_api],
  data() {
    return {
      company: null as null | Record<string, any>,
      companies: [] as Record<string, any>[],
    }
  },

  beforeMount() {
    this.fetchCompanies('')
  },

  methods: {
    fetchCompanies(term: string) {
      this.search(term, this)
    },

    search: throttle((term: string, comp: any) => {
      comp.searchCompanies(term).then((result: any) => {
        comp.companies = result.data.companies
      })
    }, 500),

    selected() {
      this.$emit('input', this.company.code)
    },
  },
})
</script>
